<template>
  <!-- 限时抢购 -->
  <div class="homepage-recommand-cruises">
    <ul
        class="cruise-content"
        ref="cruiseContent"
        @mousedown="startDrag"
        @mousemove="onDrag"
        @mouseup="stopDrag"
        @mouseleave="stopDrag"
    >
      <li
          v-for="(item, index) in cruiseCategories"
          :key="index"
          class="cruise-link"
          @click.stop="
          onCruiseClick(
            item.shipCode,
            item.sailDate,
            item.isRow,
						index
          )
        "
          :data-cruisecategoryid="item.cruiseCategoryId"
      >
        <div class="cruise-image-content">
          <div class="img-tag" v-if="item.tag && item.tag.length > 0">
            <div class="tag-text">{{ item.tag }}</div>
          </div>
          <img
              class="heart inWishList"
              v-if="item.inWish"
              @click.stop="onWishListClick(item)"
              src="https://resource.rcclchina.com.cn/homePage/heart.png"
          />
          <img
              class="heart notInWishList"
              v-else
              @click.stop="onWishListClick(item)"
              src="https://resource.rcclchina.com.cn/homePage/nullHeart.png"
          />

          <div class="cruise-img">
            <img
                class="cru-img1"
                style="width: 100%"
                :src="item.pcImage"
                alt="Alternate Text"
            />
            <div class="cruise-img-line"></div>
            <img
                v-if="item.shipCoverImage && item.shipCoverImage.length > 0"
                class="cru-img2"
                style="width: 100%"
                :src="item.shipCoverImage"
                alt=""
            />
            <img v-else class="f-dn" />
            <div class="ship">
              {{ item.shipCNName }}
              <img
                  id="selectMoreIcon"
                  style="margin-left: 4px"
                  src="https://resource.rcclchina.com.cn/tui2/list/icon-more-select-up.png"
              />
            </div>
          </div>
        </div>
        <div class="cruise-intro">
          <div class="cruise-title">
            <div class="text">
              {{ getCruiseName(item) }}
            </div>

            <div class="time">
              {{
                item.sailDateBegin.substring(0, 10) + " - " + item.sailDateEnd.substring(0, 10)
              }}&nbsp;{{ getRouteNight(item) }}
            </div>
          </div>
          <div class="cruise-booking-content" v-if="item.netAmount <= 0">
            <p class="price">售罄</p>
          </div>
          <div class="cruise-booking-content" v-else>
            <p class="price">
              {{ item.isNrp ? "早订特惠价" : "限时优惠价" }}
              <span><i style="font-size: 14px">￥</i>{{ item.netAmount.toFixed(0)}}</span>
              <i style="font-size: 14px">/人起</i>
            </p>
            <p
                class="dataTime"
                data-timer="@timespan"
                v-if="isShowCountDown(item)"
            >
              <img
                  src="https://resource.rcclchina.com.cn/homePage/time.png"
                  alt=""
              />
              <CruiseCountDown :countDownNum="getCountDown(item)" />
              <a class="link order hasCountDown" href="javascript:;"
              >立即预订</a
              >
            </p>
            <p class="dataTime" v-else>
              <a class="link order" href="javascript:;">立即预订</a>
            </p>
          </div>
        </div>
      </li>
    </ul>
    <LoginModal
        v-if="isShowLoginPopup"
        :onLoginSuccessHandler="onLoginSuccessHandler"
        :isShow="isShowLoginPopup"
    />
  </div>
</template>


<script>
import _ from "lodash";
import { gioAdsTracking } from "@/utilities/tools";
const CruiseCountDown = () => import("@/components/Home/CruiseCountDown");
const LoginModal = () => import("@/components/User/LoginModal.vue");
import api from "@/api";
export default {
  name: "OutOfStockCruiseList",
  components: {
    CruiseCountDown,
    LoginModal,
  },
  props: {
    cruiseCategories: {
      type: Array,
      default: () => {
        return [];
      },
    },
    promoCruiseItems: {
      type: Array,
      default: () => {
        return [];
      },
    },
    stateroomType:{
      type:String,
      default:''
    },
    guestNumberCount:{
      default:''
    }
  },
  data() {
    return {
      currentIndex: 0,
      isShowLoginPopup: false,
      loginCallback: null,
      isDragging: false,
      dragStartX: 0,
      scrollLeft: 0,
      dragDistance: 0,
      dragThreshold: 5, // 设置滑动阈值
    };
  },
  mounted() {
    // 给ul元素添加ref以便在methods中引用
    this.$nextTick(() => {
      this.$refs.cruiseContent = this.$el.querySelector('.cruise-content');
    });
  },
  methods: {
    getCruiseItems(categoryId) {
      let cruiseItems = this.promoCruiseItems.filter(
          (item) => item.cruiseCategoryId == categoryId && item
      );
      cruiseItems = _.orderBy(cruiseItems, "sortNumber", "desc");
      if (cruiseItems.length > 3) {
        cruiseItems = _.slice(cruiseItems, 0, 3);
      }
      return cruiseItems;
    },
    onCruiseClick(shipCode, sailDate, isRow, index) {
      if (this.dragDistance > this.dragThreshold) return;
      let date = sailDate.split("T")[0];
      let url = isRow ? `${process.env.VUE_APP_TUI_URL}/Cruise/CruiseDetail?sailDate=${sailDate}&shipCode=${shipCode}`
          : `${process.env.VUE_APP_BASE_URL}/Rccl.Cruise/CruiseDetail?sailDate=${sailDate}&shipCode=${shipCode}`;
      const eventObject = {
        "adsType": "ls",
        "lsCatOrder": this.currentIndex+1,
        "lsItmOrder": index+1,
        "desUrl": url
      }
      gioAdsTracking(eventObject);
      if (isRow) {
        window.open(`${process.env.VUE_APP_TUI_URL}/Cruise/CruiseDetail?shipCode=${shipCode}&sailDate=${date}&hmsr=out_of_stock_customization&hmpl=${shipCode+sailDate.replace(/-/g, '')}&hmcu=${this.guestNumberCount}&hmkw=${this.stateroomType}`)

      } else {
        window.open(`/Rccl.Cruise/CruiseDetail?shipCode=${shipCode}&sailDate=${date}&hmsr=out_of_stock_customization&hmpl=${shipCode+sailDate.replace(/-/g, '')}&hmcu=${this.guestNumberCount}&hmkw=${this.stateroomType}`)
      }
    },
    getCruiseName(item) {
      let cruiseName = item.cruiseName;
      if (cruiseName > 49) {
        cruiseName = cruiseName.substr(0, 49) + "..";
      }
      return cruiseName;
    },
    getRouteNight(item) {
      const sailDays = item.routeDays;
      return `${sailDays}天${sailDays - 1}晚`;
    },
    isShowCountDown(item) {
      let now = new Date();
      const endTime = item.promoEndTime;
      const moreDate = now.setTime(now.getTime() + 72 * 60 * 60 * 1000);
      let checkEndTime = 0;
      if (endTime && endTime.length > 0) {
        checkEndTime = new Date(endTime.replace("T", " ")).getTime();
        return item.isShowCountDown && checkEndTime < moreDate;
      }
      return false;
    },
    getCountDown(item) {
      const endTime = item.promoEndTime;
      let checkEndTime = 0;
      if (endTime && endTime.length > 0) {
        checkEndTime = new Date(endTime.replace("T", " ")).getTime();
      }
      return checkEndTime;
    },
    onCategoryClick(index) {
      this.currentIndex = index;
      const eventObject = {
        "adsType": "ls",
        "lsCatOrder": index+1
      }
      gioAdsTracking(eventObject);
    },
    onWishListClick(item) {
      console.log('itmeitem',item)
      if (item.inWish) {
        this.deleteWishList(item);
      } else {
        console.log(1)
        this.addWishList(item);
      }
    },
    showLoginPopup(callback) {
      this.isShowLoginPopup = true;
      this.loginCallback = callback;
    },
    onLoginSuccessHandler() {
      this.isShowLoginPopup = false;
      if (this.loginCallback) {
        this.loginCallback();
        this.loginCallback = null;
      }
    },
    async addWishList(item) {
      const userToken = this.$store.state.user.userToken;
      if (!userToken || userToken.length == 0) {
        const self = this;
        this.showLoginPopup(() => {
          self.addWishList(item);
        });
        return;
      }
      console.log(21)
      const requestData = {
        userName: userToken,
        cruiseId: item.cruiseId,
        source: "PC",
      };
      this.$loading.show();
      const { success } = await api.cruise.addWishList(requestData);
      if (success) {
        item.inWish = true;
      }
      this.$loading.hide();
    },
    async deleteWishList(item) {
      const userToken = this.$store.state.user.userToken;
      if (!userToken || userToken.length == 0) {
        let self = this;
        this.$confirm.show("您尚未登录， 请登录之后， 再添加至心愿单", {
          confirmCallBack: () => {
            self.showLoginPopup(() => {
              self.deleteWishList();
            });
          },
        });
        return;
      }
      const requestData = {
        userName: userToken,
        cruiseId: item.cruiseId,
        source: "PC",
      };
      this.$loading.show();
      const { success } = await api.cruise.deleteWishList(requestData);
      if (success) {
        item.inWish = false;
      }
      this.$loading.hide();
    },
    startDrag(e) {
      this.isDragging = true;
      this.dragStartX = e.clientX;
      this.scrollLeft = this.$refs.cruiseContent.scrollLeft;
      this.dragDistance = 0; // 重置拖拽距离
    },

    onDrag(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      const x = e.clientX;
      const walk = x - this.dragStartX;
      this.dragDistance = Math.abs(walk); // 更新拖拽距离
      this.$refs.cruiseContent.scrollLeft = this.scrollLeft - walk;
    },

    stopDrag() {
      this.isDragging = false;
    },
  },
  computed: {},
};
</script>

<style scoped>
.homepage-recommand-cruises{
  //height: 300px;
  overflow: hidden;
}
.homepage-recommand-cruises .title {
  font-size: 30px;
  font-weight: 700;
  line-height: 78px;
  text-align: center;
  color: #282b2c
}

.homepage-recommand-cruises .cruise-nav {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  height: 50px;
  background: #f8f8f8;
  margin: 0 auto 26px;
  font-weight: 600;
  font-size: 16px
}

.homepage-recommand-cruises .cruise-nav li {
  width: 216px;
  height: 100%;
  text-align: center;
  line-height: 50px;
  background: url(https://resource.rcclchina.com.cn/homePage/homePage-libg.png) no-repeat 100%;
  cursor: pointer;
  position: relative
}

.homepage-recommand-cruises .cruise-nav li:after,.homepage-recommand-cruises .cruise-nav li:before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  height: 4px;
  width: 0;
  background-color: #0073bb;
  transition: all .25s linear
}

.homepage-recommand-cruises .cruise-nav.active-sec li {
  width: 240px
}

.homepage-recommand-cruises .cruise-nav.active-thr li {
  width: 400px
}

.homepage-recommand-cruises .cruise-nav li:last-child {
  background: none
}

.homepage-recommand-cruises .cruise-nav li:hover {
  color: #006bad
}

.homepage-recommand-cruises .cruise-nav li.active:before {
  width: 50%;
  left: 0
}

.homepage-recommand-cruises .cruise-nav li.active:after {
  width: 50%
}

.homepage-recommand-cruises .cruise-content {
  width: 100%;
  padding: 3px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
  overflow-y: auto;
  margin: 0;
  &::-webkit-scrollbar {
    display: none;
  }
}

.homepage-recommand-cruises .cruise-content.active {
  display: flex
}

.homepage-recommand-cruises .cruise-content li {
  //width: 400px;
  position: relative;
  padding: 10px 10px 0;
  box-sizing: border-box;
  transition: all .5s;
  margin-right: 5px;
  cursor: pointer
}

.homepage-recommand-cruises .cruise-content li:hover {
  transform: translateZ(8px);
  box-shadow: 0 0 12px 7px rgba(46,65,80,.1)
}

.homepage-recommand-cruises .cruise-content li .img-tag {
  position: absolute;
  left: 10px;
  top: 36px;
  width: 108px;
  height: 37px;
  background: url(https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/bg-tag-1.jpg) no-repeat 100%;
  z-index: 2
}

.homepage-recommand-cruises .cruise-content li .img-tag .tag-text {
  height: 28px;
  line-height: 28px;
  color: #fff;
  text-align: center
}

.homepage-recommand-cruises .cruise-content li .heart {
  position: absolute;
  top: 26px;
  right: 28px;
  z-index: 2;
  cursor: pointer
}

.homepage-recommand-cruises .cruise-content li .cruise-img {
  width: 220px;
  height: 241px;
  overflow: hidden;
  position: relative;
  z-index: -1
}

.homepage-recommand-cruises .cruise-content li .cruise-img img {
  position: absolute;
  left: 0;
  top: 0
}

.homepage-recommand-cruises .cruise-content li .cruise-img .cruise-img-line {
  position: absolute;
  height: 2px;
  width: 100%;
  background-color: #1178ab;
  bottom: 0
}

.homepage-recommand-cruises .cruise-content li .cruise-img img.cru-img1 {
  z-index: -2;
  height: 100%
}

.homepage-recommand-cruises .cruise-content li .cruise-img img.cru-img2 {
  top: 100%;
  transition: top .5s;
  z-index: 1
}

.homepage-recommand-cruises .cruise-content li .cruise-image-content:hover img.cru-img2 {
  top: 0
}

.homepage-recommand-cruises .cruise-content li .cruise-intro {
  font-size: 14px;
  color: #2e2e2e;
  position: relative
}

.homepage-recommand-cruises .cruise-content li .cruise-intro .cruise-title {
  padding: 10px 14px 0 14px;
  font-size: 14px;
  color: #282b2c;
  font-weight: 500;
}

.homepage-recommand-cruises .cruise-content li .cruise-img .ship {
  width: 74px;
  height: 20px;
  background: rgba(0,115,187,.9);
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%,0);
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  color: #fff;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  cursor: pointer;
  display: block
}

.homepage-recommand-cruises .cruise-content li .cruise-img .ship img {
  position: relative;
  top: auto;
  left: auto
}

.homepage-recommand-cruises .cruise-content li .cruise-intro .text {
  font-size: 12px;
  color: #282b2c;
  font-weight: 700;
  overflow: hidden;
  height: 32px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical
}


.homepage-recommand-cruises .cruise-content li .cruise-intro .time {
  font-size: 11px;
  color: #2e2e2e;
}

.homepage-recommand-cruises .cruise-content li .cruise-intro .price {
  padding: 0 14px 0 14px;
  font-size: 10px;
  color: #282b2c;
  margin-bottom: 0;
}

.homepage-recommand-cruises .cruise-content li .cruise-intro .price span {
  font-size: 14px;
  font-weight: 700;
  color: #ffa400;
}

.homepage-recommand-cruises .cruise-content li .cruise-intro .price span i {
  font-size: 16px;
  font-weight: 700;
  font-style: normal;
  color: #ffa400;
}

.homepage-recommand-cruises .cruise-content li .cruise-intro .dataTime {
  //line-height: 50px;
  position: relative;
  background: #f8f8f8;
  font-weight: 500;
  overflow: hidden
}

.homepage-recommand-cruises .cruise-content li .cruise-intro .dataTime>img {
  position: absolute;
  top: 15px;
  left: 15px
}

.homepage-recommand-cruises .cruise-content li .cruise-intro .dataTime span {
  color: #ffa70d;
  font-size: 12px;
  font-weight: 400
}

.homepage-recommand-cruises .cruise-content li .cruise-intro .dataTime i {
  font-style: normal;
  position: relative;
  top: -2px
}

.homepage-recommand-cruises .cruise-content li .cruise-intro .dataTime .link.order {
  height: 30px;
  width: 100%
}

.homepage-recommand-cruises .cruise-content li .cruise-intro .dataTime .link.order.hasCountDown {
  height: 50px;
  width: 50%;
  float: right
}

.homepage-recommand-cruises .cruise-content li .cruise-intro .dataTime span.num:first-child {
  margin-left: 40px
}

.homepage-recommand-cruises .cruise-content li .cruise-intro .dataTime a.link {
  display: inline-block;
  width: 188px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  background: #fbc500;
  font-size: 12px;
  font-weight: bold;
  color: #000;
  float: left
}

.homepage-recommand-cruises .cruise-content li .cruise-intro .dataTime a.link:hover {
  text-decoration: none;
  background: #f8de57
}


.homepage-topics .main-topics .list-topics li {
  width: 394px;
  height: 100%;
  overflow: hidden;
  cursor: pointer;
  position: relative
}

.homepage-topics .main-topics .list-topics li img {
  transition: all .5s
}

.homepage-topics .main-topics .list-topics li:hover img {
  transform: scale(1.1)
}

.homepage-topics .main-topics .list-topics li a {
  display: block
}

.homepage-topics .main-topics .list-topics li a img {
  width: 100%
}

.homepage-ships .main-title .subtitle span {
  color: #ffa70d;
  font-weight: 400
}


.homepage-ships .ship-nav .main-nav li {
  width: 240px;
  height: 94px;
  text-align: center;
  position: relative
}

div.wrap .mask .btn-area>span {
  margin-left: 18px;
  font-size: 14px;
  color: #fff
}

div.wrap .mask .btn-area>img {
  margin-left: 2px;
  position: relative;
  top: -2px;
  margin-right: 2px
}

.homepage-reviews .rev-content .rev-list li {
  width: 294px;
  background: #fff;
  padding-bottom: 18px;
  cursor: pointer;
  display: inline-block;
  vertical-align: top;
  margin-bottom: 15px;
  overflow: hidden
}

.homepage-reviews .rev-content .rev-list li:hover {
  box-shadow: 0 0 7px 3px rgba(46,65,80,.1)
}

.homepage-reviews .rev-content .rev-list li .rev-detail .rev-pernum .en-name img {
  position: relative;
  top: -2px;
  margin-right: 6px
}

.homepage-reviews .rev-content .rev-list li .rev-detail .rev-pernum .en-num img {
  position: relative;
  top: -4px;
  margin-right: 2px
}


.homepage-ships .ship-nav.is-full .main-nav li {
  flex: 1;
  display: flex;
  flex-flow: column;
  justify-content: center;
  gap: 10px;
  height: 100px
}



.homepage-ships .ship-nav.is-full .main-nav li img {
  width: auto;
  height: 20px
}


.global-airline img {
  display: block;
  width: 100%
}

</style>